import { svgCreate as o } from "./create-svg.js";
const c = o("XMark", "1.17.0"), t = o("WineGlass", "1.17.0"), e = o("WifiTV", "1.17.0"), s = o("Wifi", "1.17.0"), r = o("Wheelchair", "1.17.0"), i = o("WaterDrop", "1.17.0"), a = o("Wallet", "1.17.0"), I = o(
  "Utensils",
  "1.17.0"
), l = o("UploadCloud", "1.17.0"), C = o("Upload", "1.17.0"), u = o("TrayTable", "1.17.0"), d = o("Trash", "1.17.0"), S = o(
  "TransportationMode",
  "1.17.0"
), g = o("Toilet", "1.17.0"), p = o("Tickets", "1.17.0"), b = o("Thumbs", "1.17.0"), h = o("Table", "1.17.0"), k = o("TV", "1.17.0"), w = o("Sunrise", "1.17.0"), A = o("Sun", "1.17.0"), M = o("Stars", "1.17.0"), m = o("Star", "1.17.0"), T = o("Spinner", "1.17.0"), B = o("Sort", "1.17.0"), D = o("Social", "1.17.0"), P = o(
  "Snowflake",
  "1.17.0"
), y = o("Silence", "1.17.0"), f = o("SignPost", "1.17.0"), R = o("SignOut", "1.17.0"), L = o("ShinyBubbles", "1.17.0"), W = o("Shield", "1.17.0"), v = o("Share", "1.17.0"), E = o("SecurityCamera", "1.17.0"), x = o(
  "SeatedPassenger",
  "1.17.0"
), F = o("SeatSize", "1.17.0"), H = o("SeatBelt", "1.17.0"), G = o("Ribbon", "1.17.0"), z = o("Review", "1.17.0"), U = o("ReservedSeat", "1.17.0"), V = o("Report", "1.17.0"), O = o("Refund", "1.17.0"), Q = o("Radio", "1.17.0"), K = o("Rabbit", "1.17.0"), N = o("QuestionMarkCircle", "1.17.0"), X = o("QrCode", "1.17.0"), j = o(
  "PowerOutlet",
  "1.17.0"
), q = o("Plus", "1.17.0"), J = o("PinDrop", "1.17.0"), Y = o("Person", "1.17.0"), Z = o("Pencil", "1.17.0"), _ = o("Paw", "1.17.0"), $ = o("Paperclip", "1.17.0"), oo = o("PanoramicView", "1.17.0"), no = o("NoFees", "1.17.0"), co = o("Moon", "1.17.0"), to = o("Minus", "1.17.0"), eo = o("Minimize", "1.17.0"), so = o("MeetingTable", "1.17.0"), ro = o("Maximize", "1.17.0"), io = o("Marker", "1.17.0"), ao = o("Map", "1.17.0"), Io = o("MagnifyingGlass", "1.17.0"), lo = o("Luggage", "1.17.0"), Co = o(
  "LongArrow",
  "1.17.0"
), uo = o("Lock", "1.17.0"), So = o("Location", "1.17.0"), go = o("Leaf", "1.17.0"), po = o("InfoCircle", "1.17.0"), bo = o("Inbox", "1.17.0"), ho = o("ID", "1.17.0"), ko = o("House", "1.17.0"), wo = o(
  "HotDrink",
  "1.17.0"
), Ao = o("Heating", "1.17.0"), Mo = o("Heart", "1.17.0"), mo = o("HamburgerMenu", "1.17.0"), To = o("Globe", "1.17.0"), Bo = o("Gender", "1.17.0"), Do = o("Flag", "1.17.0"), Po = o("Filters", "1.17.0"), yo = o("Film", "1.17.0"), fo = o("FerrisWheel", "1.17.0"), Ro = o("Eye", "1.17.0"), Lo = o("ExternalLink", "1.17.0"), Wo = o(
  "ExclamationMarkCircle",
  "1.17.0"
), vo = o("Envelope", "1.17.0"), Eo = o(
  "Ellipsis",
  "1.17.0"
), xo = o("Download", "1.17.0"), Fo = o("Discount", "1.17.0"), Ho = o("Diamond", "1.17.0"), Go = o(
  "CurvedArrow",
  "1.17.0"
), zo = o(
  "Currency",
  "1.17.0"
), Uo = o("CreditCard", "1.17.0"), Vo = o("Cog", "1.17.0"), Oo = o("Clock", "1.17.0"), Qo = o("City", "1.17.0"), Ko = o("Chevron", "1.17.0"), No = o(
  "Checkpoint",
  "1.17.0"
), Xo = o(
  "CheckCircle",
  "1.17.0"
), jo = o("Check", "1.17.0"), qo = o("ChartArea", "1.17.0"), Jo = o("Caret", "1.17.0"), Yo = o("Camera", "1.17.0"), Zo = o(
  "CalendarDate",
  "1.17.0"
), _o = o("Calendar", "1.17.0"), $o = o("BusbudCoin", "1.17.0"), on = o("Busbud", "1.17.0"), nn = o("Bug", "1.17.0"), cn = o("Box", "1.17.0"), tn = o("Bolt", "1.17.0"), en = o("Bicycle", "1.17.0"), sn = o("Ban", "1.17.0"), rn = o("Bag", "1.17.0"), an = o("Attendant", "1.17.0"), In = o("ArrowTopDown", "1.17.0"), ln = o("ArrowLeftRight", "1.17.0"), Cn = o(
  "ArrowBiDirectional",
  "1.17.0"
), un = o("Arrow", "1.17.0"), dn = o("Armchair", "1.17.0"), Sn = o("Apple", "1.17.0"), gn = o("AidKit", "1.17.0"), pn = o("Activity", "1.17.0"), bn = o("AED", "1.17.0");
export {
  bn as IconAED,
  pn as IconActivity,
  gn as IconAidKit,
  Sn as IconApple,
  dn as IconArmchair,
  un as IconArrow,
  Cn as IconArrowBiDirectional,
  ln as IconArrowLeftRight,
  In as IconArrowTopDown,
  an as IconAttendant,
  rn as IconBag,
  sn as IconBan,
  en as IconBicycle,
  tn as IconBolt,
  cn as IconBox,
  nn as IconBug,
  on as IconBusbud,
  $o as IconBusbudCoin,
  _o as IconCalendar,
  Zo as IconCalendarDate,
  Yo as IconCamera,
  Jo as IconCaret,
  qo as IconChartArea,
  jo as IconCheck,
  Xo as IconCheckCircle,
  No as IconCheckpoint,
  Ko as IconChevron,
  Qo as IconCity,
  Oo as IconClock,
  Vo as IconCog,
  Uo as IconCreditCard,
  zo as IconCurrency,
  Go as IconCurvedArrow,
  Ho as IconDiamond,
  Fo as IconDiscount,
  xo as IconDownload,
  Eo as IconEllipsis,
  vo as IconEnvelope,
  Wo as IconExclamationMarkCircle,
  Lo as IconExternalLink,
  Ro as IconEye,
  fo as IconFerrisWheel,
  yo as IconFilm,
  Po as IconFilters,
  Do as IconFlag,
  Bo as IconGender,
  To as IconGlobe,
  mo as IconHamburgerMenu,
  Mo as IconHeart,
  Ao as IconHeating,
  wo as IconHotDrink,
  ko as IconHouse,
  ho as IconID,
  bo as IconInbox,
  po as IconInfoCircle,
  go as IconLeaf,
  So as IconLocation,
  uo as IconLock,
  Co as IconLongArrow,
  lo as IconLuggage,
  Io as IconMagnifyingGlass,
  ao as IconMap,
  io as IconMarker,
  ro as IconMaximize,
  so as IconMeetingTable,
  eo as IconMinimize,
  to as IconMinus,
  co as IconMoon,
  no as IconNoFees,
  oo as IconPanoramicView,
  $ as IconPaperclip,
  _ as IconPaw,
  Z as IconPencil,
  Y as IconPerson,
  J as IconPinDrop,
  q as IconPlus,
  j as IconPowerOutlet,
  X as IconQrCode,
  N as IconQuestionMarkCircle,
  K as IconRabbit,
  Q as IconRadio,
  O as IconRefund,
  V as IconReport,
  U as IconReservedSeat,
  z as IconReview,
  G as IconRibbon,
  H as IconSeatBelt,
  F as IconSeatSize,
  x as IconSeatedPassenger,
  E as IconSecurityCamera,
  v as IconShare,
  W as IconShield,
  L as IconShinyBubbles,
  R as IconSignOut,
  f as IconSignPost,
  y as IconSilence,
  P as IconSnowflake,
  D as IconSocial,
  B as IconSort,
  T as IconSpinner,
  m as IconStar,
  M as IconStars,
  A as IconSun,
  w as IconSunrise,
  k as IconTV,
  h as IconTable,
  b as IconThumbs,
  p as IconTickets,
  g as IconToilet,
  S as IconTransportationMode,
  d as IconTrash,
  u as IconTrayTable,
  C as IconUpload,
  l as IconUploadCloud,
  I as IconUtensils,
  a as IconWallet,
  i as IconWaterDrop,
  r as IconWheelchair,
  s as IconWifi,
  e as IconWifiTV,
  t as IconWineGlass,
  c as IconXMark
};
